const NUMERALS: [number, string][] = [
  [1000, 'M'],
  [900, 'CM'],
  [500, 'D'],
  [400, 'CD'],
  [100, 'C'],
  [90, 'XC'],
  [50, 'L'],
  [40, 'XL'],
  [10, 'X'],
  [9, 'IX'],
  [5, 'V'],
  [4, 'IV'],
  [1, 'I'],
]

/**
 * A year in Roman numerals — the club sets dates in numerals, and the
 * membership card is the one place that has to keep doing so.
 *
 * The club's OWN founding year is a constant in the copy ("chartered MMXXVI")
 * and stays that way; this exists only for dates the club was actually told,
 * so that a member's card can stop asserting one it wasn't.
 */
export function romanYear(year: number): string {
  if (!Number.isFinite(year) || year <= 0) return ''

  let remaining = Math.floor(year)
  let out = ''
  for (const [value, numeral] of NUMERALS) {
    while (remaining >= value) {
      out += numeral
      remaining -= value
    }
  }
  return out
}
